







import {
  apiV1AdminRecommendsPath,
} from '@/rails/routes'
import axios from 'axios'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import Recommend from '@/models/Recommend'
import {Component} from 'vue-property-decorator'
import RecommendForm from '@/components/admin/recommends/Form.vue'

@Component({
  components: {
    RecommendForm
  }
})
export default class RecommendNew extends PageBase {
  recommend: Recommend = new Recommend()

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'おすすめ求人一覧',
        to: '/admin/recommends',
        exact: true
      },
      {
        text: 'おすすめ求人新規作成'
      }
    ]
  }

  async mounted(): Promise<void> {
    super.mounted()
  }

  async save(): Promise<void> {
    try {
      if(!this.recommend.name) {
        this.showError('タイトルを入力してください')
        return
      }
      if (this.recommend.active == null) {
        this.showError('表示ステータスを入力してください')
        return
      }
      if (!this.recommend.medium) {
        this.showError('画像を選択してください')
        return
      }
      this.showLoading()
      await axios.post(apiV1AdminRecommendsPath(), {
        recommend: this.recommend.toParams()
      })
      this.hideLoading()
      await this.$router.push('/admin/recommends')
      this.showMessage('変更を保存しました。')
    } catch(e) {
      console.error(e)
    }
  }
}
